import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import styles from './SelectableItem.scss';

import { getDisplayName } from '../../utils';

export const selectableCheckbox = (Item) =>
  class extends PureComponent {
    static displayName = `Selectable(${getDisplayName(Item)})`;

    static propTypes = {
      isChecked: PropTypes.bool.isRequired,
      onChange: PropTypes.func.isRequired,
      onBlur: PropTypes.func.isRequired,
      id: PropTypes.string.isRequired,
      input: PropTypes.shape({}),
    };

    static defaultProps = {
      input: {},
    };

    render() {
      const { input, onChange, onBlur, ...clearProps } = this.props;
      const { id, isChecked } = clearProps;
      const classNames = `${styles.selectableItem} ${isChecked ? styles.checked : ''}`;

      return (
        <div className={styles.wrapper}>
          <Item {...clearProps} {...input} />
          <label className={classNames} htmlFor={id}>
            <input
              type="checkbox"
              id={id}
              className={styles.hiddenCheckbox}
              checked={isChecked}
              onChange={onChange}
              onBlur={onBlur}
            />
            <span className={styles.fakeInput} />
          </label>
        </div>
      );
    }
  };
